import { useEffect, useState } from "react";
import { rpc } from "../lib/rpc";
import { counts as opCounts } from "../lib/opQueue";

/**
 * P-6: real Offline-Queue counts (IndexedDB-basiert).
 */
export function usePendingOps() {
    const [pendingOps, setPendingOps] = useState(0);
    useEffect(() => {
        let cancelled = false;
        const tick = async () => {
            try {
                const c = await opCounts();
                if (!cancelled) setPendingOps(c.unresolved || 0);
            } catch (_e) { /* ignore */ }
        };
        tick();
        const iv = setInterval(tick, 3000);
        return () => {
            cancelled = true;
            clearInterval(iv);
        };
    }, []);
    return { pendingOps };
}

/**
 * Lightweight ressource-fetcher für Mobile-Listen.
 */
export function useApi(path, deps = []) {
    const [state, setState] = useState({ loading: true, data: null, error: null });
    useEffect(() => {
        let cancelled = false;
        setState((s) => ({ ...s, loading: true }));
        rpc.get(path).then((res) => {
            if (cancelled) return;
            if (res.ok) setState({ loading: false, data: res.data, error: null });
            else setState({ loading: false, data: null, error: res.error });
        });
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return state;
}
